import type {
  PurchaserId,
  Organization,
  ReportType,
  ReportFileType,
  ReportParams,
} from '@openeducation/oe-rn-shared-types';

import HRPortalReportsDao from '../dao/hr-portal-reports.dao';
import type { Environment } from '../interfaces/environment';

export abstract class HRPortalReportsService {
  static async getReport(
    env: Environment,
    accessToken: string,
    purchaserId: PurchaserId,
    organization: Organization,
    reportType: ReportType,
    fileType: ReportFileType,
    params?: ReportParams
  ) {
    if (!accessToken) {
      throw new Error('No accessToken provided');
    }
    if (!purchaserId) {
      throw new Error('No purchaser id provided');
    }
    if (!organization) {
      throw new Error('No organization provided');
    }
    if (!reportType) {
      throw new Error('No report type provided');
    }
    if (!fileType) {
      throw new Error('No file type provided');
    }
    const response = await HRPortalReportsDao.getReport(
      env,
      accessToken,
      purchaserId,
      organization,
      reportType,
      fileType,
      params
    );
    return response;
  }
}
